module.exports = __webpack_public_path__ + "static/media/transporter.3ac89c2d.svg";